import { apiDlUrl } from '@/environment/environment';

export const apiConstants = {
  fetchGuide: 'mock-data/analyze/guide.json',
  fetchTags: 'mock-data/tags.json',
  fetchArtefacts: 'mock-data/analyze/artefacts.json',
  fetchArtefact: 'mock-data/analyze/artefact.json',
  fetchArtifactUnit: 'mock-data/analyze/artefactUnit.json',
  // sfm: apiDlUrl+'clifsmoversnew',

  eusers: 'mock-data/onboard/entity-users.json',
  euser: 'mock-data/onboard/entity-user.json',
};
